export default function initTooltip() {
  var tooltipOpener = $('.confirm-open');
  var tooltipCloser = $('.confirm-close');
  var tooltip = $('.confirm-tooltip');
  var classActive = 'active';

  function tooltipOpen(e) {
    e.preventDefault();
    tooltip.removeClass(classActive);
    $(this).siblings(tooltip).addClass(classActive);
  }
  function tooltipClose(e) {
    e.preventDefault();
    tooltip.removeClass(classActive);
  }

  tooltipOpener.on('click', tooltipOpen);
  tooltipCloser.on('click', tooltipClose);
}